/** Hidden ways to reveal the admin email form. The server allowlist still decides who can sign in. */

export const ADMIN_LOGO_TAPS = 5;
export const ADMIN_LOGO_WINDOW_MS = 3000;

export function isAdminLoginPath(pathname: string, search: string): boolean {
  const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  if (path === '/admin-login') return true;
  if (path !== '/login') return false;
  return new URLSearchParams(search).get('admin') === '1';
}

export function isAdminLoginShortcut(event: {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  repeat?: boolean;
}): boolean {
  if (event.repeat) return false;
  if (!(event.ctrlKey || event.metaKey) || !event.shiftKey) return false;
  return event.key === 'a' || event.key === 'A';
}

/** Record a logo tap. Five taps inside a 3 second window open the form and clear the sequence. */
export function logoTapsOpenAdmin(previousTaps: readonly number[], now: number): { open: boolean; taps: number[] } {
  const taps = previousTaps.filter((tap) => now - tap <= ADMIN_LOGO_WINDOW_MS);
  taps.push(now);
  if (taps.length >= ADMIN_LOGO_TAPS) return { open: true, taps: [] };
  return { open: false, taps };
}
